/**
 * Manage tab (plan section 13 tab 7; admin only): a SegmentedTabs shell over
 * the sub-views in tabs/manage/subviews.ts (Catalog, Groups, Assign,
 * Campaigns, Onboarding templates, Settings).
 *
 * Hot file (plan 15.12): WP-03 only. The sub-view WPs (WP-43, WP-44, WP-47,
 * WP-48) replace the placeholder file their registry entry imports and never
 * edit this one. LmsApp mounts it at /lms/manage/* behind the admin check.
 */
import { SubviewHost } from '../../components/SubviewHost';
import { lmsTab } from '../config';
import { MANAGE_SUBVIEWS } from './subviews';

const TAB = lmsTab('manage');

export function ManageTab() {
  return <SubviewHost tab={TAB} subviews={MANAGE_SUBVIEWS} />;
}

export default ManageTab;
